<template>
  <div>
      <v-row>
          <v-col cols="12" md="6" sm="6">
              <v-card class="ml-3">
                  <v-card-title>{{ $t('debtor') }}</v-card-title>
                  <v-card-text>
                      <PartyForm :values="debtor" :errors="partyViolations" :success="partyCreated !== null"/>
                      <v-btn v-if="partyCreated === null" color="primary" @click="createDebtor">{{ $t('next') }}</v-btn>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col cols="12" md="6" sm="6">
              <v-card v-if="item.debtor !== ''" class="ml-3">
                  <v-card-title>{{ $t('CreditTransferPaymentRun') }}</v-card-title>
                  <v-card-text>
                      <CreditTransferPaymentRunForm :debtor="item.debtor" :values="item" :errors="violations" />
                      <v-btn color="primary" @click="createRun">{{ $t('create') }}</v-btn>
                  </v-card-text>
              </v-card>
          </v-col>
      </v-row>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import CreditTransferPaymentRunForm from '../../components/credittransferpaymentrun/Form';
import PartyForm from '../../components/party/Form';
import Loading from '../../components/Loading';

const servicePrefix = 'CreditTransferPaymentRun';

export default {
  name: 'CreditTransferPaymentRunCreate',
  servicePrefix,
  components: {
    Loading,
    CreditTransferPaymentRunForm,
    PartyForm
  },
  data() {
    return {
      debtor: {
          sepaInfo:  {
              name: '',
              IBAN: '',
              BIC: ''
          }
      },
      item: {
          debtor: '',
          createdAt: new Date().toISOString().substr(0, 10),
          dueAt: new Date().toISOString().substr(0, 10)
      }
    };
  },
  computed: {
    ...mapFields('credittransferpaymentrun', ['error', 'isLoading', 'created', 'violations']),
    ...mapFields('party', {
        partyError: 'error',
        partyLoading: 'isLoading',
        partyCreated: 'created',
        partyViolations: 'violations'
    }),
  },
  methods: {
    ...mapActions('credittransferpaymentrun', ['create', 'reset']),
    ...mapActions('party', {
      createParty: 'create'
    }),
    createDebtor() {
      this.createParty(this.debtor);
    },
    createRun() {
      this.create(this.item);
    }
  },
  watch: {
    partyCreated(v) {
      this.item.debtor = v['@id'];
    },
    error(message) {
      message && this.showError(message);
    },
    created(v) {
      if (v) {
        this.partyCreated = null;
        this.$router.push({
          name: 'AddTransfersToRunCreate',
          params: { id: v['@id'] }
        })
      }
    }
  }
};
</script>
